import React, { memo } from 'react';
import ComparadorFundosProvider from '../../contexts/ComparadorFundosContext';
import ComparadorFundosContent from './ComparadorFundosContent';

const ComparadorFundos = memo(() => {
  return (
    <ComparadorFundosProvider>
      <ComparadorFundosContent />
    </ComparadorFundosProvider>
  );
});

export default ComparadorFundos;
